import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 17000-17999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const tasksErrors = {
  // 17xxx is the Tasks module's series. These two replace the STRING values that
  // `TASK_ERROR_CODE` (tasks/tasks.constant.ts) used to own ("TASK_STALE_UPDATE",
  // "TASK_CUSTOM_FIELDS_VALIDATION_FAILED"). The constant object itself is kept — every consumer,
  // server and web, references `TASK_ERROR_CODE.X` rather than a duplicated literal, so only the
  // VALUES moved here and no call site changed. Distinct from TASK_NOT_FOUND (16005), which belongs
  // to the comments module's task lookups.
  //
  // `updateTask`: the task changed since the client loaded it (optimistic-concurrency miss).
  TASK_STALE_UPDATE: {
    errorCode: 17001,
    errorMessage: t("This task changed since you opened it. Reload and apply your changes again."),
    isDynamic: false,
  },
  // `updateTaskCustomFields`: the submitted custom fields failed their template rules.
  TASK_CUSTOM_FIELDS_VALIDATION_FAILED: {
    errorCode: 17002,
    errorMessage: t("Fill all fields according to the rules before saving."),
    isDynamic: false,
  },
  TASK_SPACE_RECORD_STATUS_MISSING: {
    errorCode: 17003,
    errorMessage: t("Space is missing its record status."),
    isDynamic: false,
  },
  TASK_PROJECT_NO_FORM_TEMPLATE: {
    errorCode: 17004,
    errorMessage: t("This project has no tasks form template."),
    isDynamic: false,
  },
  TASK_PROJECT_RECORD_STATUS_MISSING: {
    errorCode: 17005,
    errorMessage: t("Project is missing its record status."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
